// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseAttribute } from './BaseAttribute';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 完整属性 实体类
 * 完整定义的属性基类
 */
export abstract class CompleteAttribute extends BaseAttribute {
  /** 是否是标题 : 是否是标题属性，每个实体有且仅有一个标题属性，且不为空 */
  private _isTitle: boolean;

  /** 设置：是否是标题 */
  public get isTitle() {
    return this._isTitle;
  }

  /** 获取：是否是标题 */
  public set isTitle(value: boolean) {
    this._isTitle = value;
  }

  /** 长度 : 定义数据类型的长度 */
  private _length: number;

  /** 设置：长度 */
  public get length() {
    return this._length;
  }

  /** 获取：长度 */
  public set length(value: number) {
    this._length = value;
  }

  /** 精度 : 数字型属性的精度，-1为不限制 */
  private _precision: number;

  /** 设置：精度 */
  public get precision() {
    return this._precision;
  }

  /** 获取：精度 */
  public set precision(value: number) {
    this._precision = value;
  }

  /** 小数位数 : 数字型属性的小数位数，针对浮点数值 */
  private _scale: number;

  /** 设置：小数位数 */
  public get scale() {
    return this._scale;
  }

  /** 获取：小数位数 */
  public set scale(value: number) {
    this._scale = value;
  }

  /** 是否可空 : 是否可允许空 */
  private _isNullable: boolean;

  /** 设置：是否可空 */
  public get isNullable() {
    return this._isNullable;
  }

  /** 获取：是否可空 */
  public set isNullable(value: boolean) {
    this._isNullable = value;
  }

  /** 缺省值 : 缺省值，初始化的时候赋值 */
  private _defaultValue: string;

  /** 设置：缺省值 */
  public get defaultValue() {
    return this._defaultValue;
  }

  /** 获取：缺省值 */
  public set defaultValue(value: string) {
    this._defaultValue = value;
  }

  /** 校验表达式 : 校验表达式，使用正则表达式，如果为空则不做校验 */
  private _validateExpress: string;

  /** 设置：校验表达式 */
  public get validateExpress() {
    return this._validateExpress;
  }

  /** 获取：校验表达式 */
  public set validateExpress(value: string) {
    this._validateExpress = value;
  }

  /** 是否校验 : 是否对参数进行校验 */
  private _isValidate: boolean;

  /** 设置：是否校验 */
  public get isValidate() {
    return this._isValidate;
  }

  /** 获取：是否校验 */
  public set isValidate(value: boolean) {
    this._isValidate = value;
  }

  /** 验证失败提示消息 : 正则表达式验证失败后的提示消息 */
  private _errorMessage: string;

  /** 设置：验证失败提示消息 */
  public get errorMessage() {
    return this._errorMessage;
  }

  /** 获取：验证失败提示消息 */
  public set errorMessage(value: string) {
    this._errorMessage = value;
  }

  /** 最大值 : 参数允许的最大值（包含本身），不定义则不起效 */
  private _maxValue: string;

  /** 设置：最大值 */
  public get maxValue() {
    return this._maxValue;
  }

  /** 获取：最大值 */
  public set maxValue(value: string) {
    this._maxValue = value;
  }

  /** 最小值 : 参数允许的最小值（包含本身），不定义则不起效 */
  private _minValue: string;

  /** 设置：最小值 */
  public get minValue() {
    return this._minValue;
  }

  /** 获取：最小值 */
  public set minValue(value: string) {
    this._minValue = value;
  }

  /** 是否包含中文 : 是否包含Unicode字符。 */
  private _isUnicode: boolean;

  /** 设置：是否包含中文 */
  public get isUnicode() {
    return this._isUnicode;
  }

  /** 获取：是否包含中文 */
  public set isUnicode(value: boolean) {
    this._isUnicode = value;
  }

  /** 是否固定长度 : 是否固定长度 */
  private _isFixLength: boolean;

  /** 设置：是否固定长度 */
  public get isFixLength() {
    return this._isFixLength;
  }

  /** 获取：是否固定长度 */
  public set isFixLength(value: boolean) {
    this._isFixLength = value;
  }

  /** 真:显示名称 : 当数据类型为布尔型，且值为真的时候的显示名称，默认为是 */
  private _trueLabel: string;

  /** 设置：真:显示名称 */
  public get trueLabel() {
    return this._trueLabel;
  }

  /** 获取：真:显示名称 */
  public set trueLabel(value: string) {
    this._trueLabel = value;
  }

  /** 假:显示名称 : 当数据类型为布尔型，且值为假的时候的显示名称，默认为否 */
  private _falseLabel: string;

  /** 设置：假:显示名称 */
  public get falseLabel() {
    return this._falseLabel;
  }

  /** 获取：假:显示名称 */
  public set falseLabel(value: string) {
    this._falseLabel = value;
  }

  constructor() {
    super();
    this._isTitle = false;
    this._length = 50;
    this._precision = 16;
    this._scale = 2;
    this._isNullable = false;
    this._defaultValue = '';
    this._validateExpress = '';
    this._isValidate = false;
    this._errorMessage = '';
    this._maxValue = '';
    this._minValue = '';
    this._isUnicode = false;
    this._isFixLength = false;
    this._trueLabel = '是';
    this._falseLabel = '否';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: CompleteAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isTitle = element.isTitle;
      this.length = element.length;
      this.precision = element.precision;
      this.scale = element.scale;
      this.isNullable = element.isNullable;
      this.defaultValue = element.defaultValue;
      this.validateExpress = element.validateExpress;
      this.isValidate = element.isValidate;
      this.errorMessage = element.errorMessage;
      this.maxValue = element.maxValue;
      this.minValue = element.minValue;
      this.isUnicode = element.isUnicode;
      this.isFixLength = element.isFixLength;
      this.trueLabel = element.trueLabel;
      this.falseLabel = element.falseLabel;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isTitle = json.IsTitle;
    this.length = json.Length;
    this.precision = json.Precision;
    this.scale = json.Scale;
    this.isNullable = json.IsNullable;
    this.defaultValue = json.DefaultValue;
    this.validateExpress = json.ValidateExpress;
    this.isValidate = json.IsValidate;
    this.errorMessage = json.ErrorMessage;
    this.maxValue = json.MaxValue;
    this.minValue = json.MinValue;
    this.isUnicode = json.IsUnicode;
    this.isFixLength = json.IsFixLength;
    this.trueLabel = json.TrueLabel;
    this.falseLabel = json.FalseLabel;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsTitle = this.isTitle;
    json.Length = this.length;
    json.Precision = this.precision;
    json.Scale = this.scale;
    json.IsNullable = this.isNullable;
    json.DefaultValue = this.defaultValue;
    json.ValidateExpress = this.validateExpress;
    json.IsValidate = this.isValidate;
    json.ErrorMessage = this.errorMessage;
    json.MaxValue = this.maxValue;
    json.MinValue = this.minValue;
    json.IsUnicode = this.isUnicode;
    json.IsFixLength = this.isFixLength;
    json.TrueLabel = this.trueLabel;
    json.FalseLabel = this.falseLabel;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('代码属性', 'isTitle', '是否是标题', EnumDataType.Bool, this.isTitle, true, '是否是标题属性，每个实体有且仅有一个标题属性，且不为空', '', '');
    context.addRow('代码属性', 'length', '长度', EnumDataType.Int, this.length, true, '定义数据类型的长度', '', '');
    context.addRow('代码属性', 'precision', '精度', EnumDataType.Int, this.precision, true, '数字型属性的精度，-1为不限制', '', '');
    context.addRow('代码属性', 'scale', '小数位数', EnumDataType.Int, this.scale, true, '数字型属性的小数位数，针对浮点数值', '', '');
    context.addRow('代码属性', 'isNullable', '是否可空', EnumDataType.Bool, this.isNullable, true, '是否可允许空', '', '');
    context.addRow('代码属性', 'defaultValue', '缺省值', EnumDataType.String, this.defaultValue, true, '缺省值，初始化的时候赋值', '', '');
    context.addRow('校验属性', 'validateExpress', '校验表达式', EnumDataType.String, this.validateExpress, true, '校验表达式，使用正则表达式，如果为空则不做校验', '', '');
    context.addRow('校验属性', 'isValidate', '是否校验', EnumDataType.Bool, this.isValidate, true, '是否对参数进行校验', '', '');
    context.addRow('校验属性', 'errorMessage', '验证失败提示消息', EnumDataType.String, this.errorMessage, true, '正则表达式验证失败后的提示消息', '', '');
    context.addRow('校验属性', 'maxValue', '最大值', EnumDataType.String, this.maxValue, true, '参数允许的最大值（包含本身），不定义则不起效', '', '');
    context.addRow('校验属性', 'minValue', '最小值', EnumDataType.String, this.minValue, true, '参数允许的最小值（包含本身），不定义则不起效', '', '');
    context.addRow('代码属性', 'isUnicode', '是否包含中文', EnumDataType.Bool, this.isUnicode, true, '是否包含Unicode字符。', '', '');
    context.addRow('代码属性', 'isFixLength', '是否固定长度', EnumDataType.Bool, this.isFixLength, true, '是否固定长度', '', '');
    context.addRow('代码属性', 'trueLabel', '真:显示名称', EnumDataType.String, this.trueLabel, true, '当数据类型为布尔型，且值为真的时候的显示名称，默认为是', '', '');
    context.addRow('代码属性', 'falseLabel', '假:显示名称', EnumDataType.String, this.falseLabel, true, '当数据类型为布尔型，且值为假的时候的显示名称，默认为否', '', '');
  }
}
